import React from 'react';

const SearchTermHighlighter = ({
  searchTerm,
  children
}: {
  searchTerm: string;
  children: string;
}): React.ReactElement => {
  if (!searchTerm) {
    return <>{children}</>;
  }

  const regex = new RegExp(`(${searchTerm})`, 'gi');
  const highlighted = children
    .split(regex)
    .map((part, i) =>
      regex.test(part) ? (
        <strong key={`${part}${i}`}>{part}</strong>
      ) : (
        <span key={`${part}${i}`}>{part}</span>
      )
    );

  return <>{highlighted}</>;
};

export default SearchTermHighlighter;
